<template>
  <v-flex xs12 class="text-xs-center" v-if="$store.state.vehicleTypes.loadingVehicleTypes">
    <v-progress-circular indeterminate :color="$store.state.global.pages[$route.name].color"></v-progress-circular>
  </v-flex>
  <transition name="fadeToggle" mode="out-in" v-else>
    <v-flex xs12 v-if="listView">
      <v-card hover>
        <v-data-table
          :items="filteredVehicleTypes"
          :headers="headers"
          :rows-per-page-items="itemsPerPageOptions"
        >
          <template slot="items" slot-scope="props">
            <table-row
              :headers="headers"
              :row="props.item"
              parent="Vehicle.Type"
              :key="props.item.id"
            ></table-row>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>

    <transition-group name="data-list" tag="layout-no-padding" v-else>
      <v-flex
        xs12
        sm6
        md4
        xl3
        v-for="(vehicleType,i) in filteredVehicleTypes"
        :key="vehicleType.id"
        class="data-list-item"
      >
        <vehicleType-card :vehicleType="vehicleType" :index="i"></vehicleType-card>
      </v-flex>
    </transition-group>
  </transition>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import VehicleService from "@/services/requests/vehicleService";
import VehicleTypeCard from "@/components/vehicleTypes/vehicleTypeCard";
import TableRow from "@/components/ui/masterFileTableRow";
export default {
  data() {
    return {
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name"
        },
        {
          text: "Tonnage",
          align: "right",
          value: "tonnage"
        },
        {
          text: "Class",
          align: "left",
          value: "class"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false
        }
      ]
    };
  },
  computed: {
    filterBy: Store.getSet({ store: "vehicleTypes", prop: "filterBy" }),
    vehicleTypes: Store.getSet({ store: "vehicleTypes", prop: "vehicleTypes" }),
    listView: Store.getSet({ store: "vehicleTypes", prop: "listView" }),

    filteredVehicleTypes() {
      return this.vehicleTypes.filter(vehicleType => {
        return (
          vehicleType.name.toLowerCase().indexOf(this.filterBy.toLowerCase()) >
          -1
        );
      });
    }
  },
  components: {
    VehicleTypeCard,
    TableRow
  }
};
</script>

<style scoped>
</style>
